function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.974 3.161c-.495 0-.897.434-.897.968v7.742c0 .534.402.968.897.968h10.052c.495 0 .897-.434.897-.968V5.677c0-.534-.402-.967-.897-.967H8.718a.52.52 0 01-.38-.17L7.058 3.16H2.974zM1 4.13C1 2.953 1.884 2 2.974 2h4.308a.52.52 0 01.38.17l1.279 1.378h4.085c1.09 0 1.974.954 1.974 2.13v6.193C15 13.047 14.116 14 13.026 14H2.974C1.884 14 1 13.047 1 11.871V4.129z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 5.871c.297 0 .538.26.538.58v2.323c0 .32-.24.58-.538.58-.298 0-.539-.26-.539-.58V6.452c0-.321.241-.581.539-.581zm-.539 5.31c0-.32.241-.58.539-.58h.006c.298 0 .539.26.539.58 0 .321-.241.581-.539.581H8c-.298 0-.539-.26-.539-.58z"
}));
function SvgArchivoincorrecto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Archivo incorrecto.svg";
export { SvgArchivoincorrecto as ReactComponent };